/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { KTSVG } from '../../_metronic/helpers';
import { Row, Col } from 'react-bootstrap-v5';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import Select from 'react-select';
import DataTable from './DataTable';
import { Link } from 'react-router-dom';

const DashboardStoreManager = () => {

	const [dateRange] = useState('year');
	const [customDate] = useState({ customFromDate: '', customToDate: '' });
	const [newData] = useState({});

	const [dashboardData, setDashboardData] = useState({
		pendingShipments: 0,
		alreadyShipped: 0,
		productStock: 0,
		itemsInStock: 0,
		productOutOfStock: 0,
	});



	useEffect(() => {
		getProjectList()
	}, [])

	const [selectProjectOptions, setSelectProjectOptions] = useState([])
	const [project, setProject] = useState({ label: 'Select Project', value: '' });

	const handleProjectChange = (project: any) => {
		setProject(project);
	}

	useEffect(() => {
		// options.reloadMyTable();
		getUserDashboard()
		// expenseOptions.reloadMyTable();
	}, [project])

	const getProjectList = async () => {
		const url = process.env.REACT_APP_API_URL + 'projects';

		const response = await fetch(url, getRequestOptions());

		const data = await response.json();

		data.data.map((element: any) => {
			element.value = element.id_projects;
			element.label = element.project_name;
			return element;
		})

		if (data.data.length === 1) {
			setSelectProjectOptions(data.data)

		} else {
			var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
			let allProjects = data.data.concat(allProjectsOpt);
			setSelectProjectOptions(allProjects);
		}

	}

	useEffect(() => {
		if (selectProjectOptions.length === 1) {
			setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
		}
	}, [selectProjectOptions])


	const getUserDashboard = () => {
		fetch(
			// process.env.REACT_APP_API_URL + 'user/dashboard?idProjects=' + project.value,
			process.env.REACT_APP_API_URL + 'store-manager/dashboard?idProjects=' + project.value + '&type=' + dateRange + '&customFromDate=' + customDate.customFromDate + '&customToDate=' + customDate.customToDate,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				// console.log(resp, 'resp.data')
				setDashboardData({
					...dashboardData,
					pendingShipments: resp.pendingShipments,
					alreadyShipped: resp.alreadyShipped,
					productStock: resp.productStock,
					itemsInStock: resp.itemsInStock,
					productOutOfStock: resp.productOutOfStock,
				});
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const pendingDeliveryColumns = [
		{ value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { 
			value: 'salesOrderId', 
			title: 'Sales Order ID', 
			style: { textAlign: 'center' },
			hasHtmlComponent: true,
			htmlComponent: (rowValue: any) => {
				return (
					<>
						{rowValue.id ? <a href={"/#/sales-order/" + rowValue.id}>{rowValue.salesOrderId}</a> : ''}
					</>
				)
			},
		},
        { value: 'salesQuotation', title: 'Quotation', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
        { value: 'srName', title: 'SR', style: { textAlign: 'left' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'left' } },
        { value: 'orderDate', title: 'Date', style: { textAlign: 'left' } },
        { value: 'creditDays', title: 'Credit Days', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        { value: 'status', title: 'Status', style: { textAlign: 'center' } },
	]

	const pendingDeliveryFilters = {
		id: {
            filterType: 'like',
            filterValue: '',
        },
        salesOrderId: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        salesQuotation: {
            filterType: 'like',
            filterValue: '',
        },
        srName: {
            filterType: 'like',
            filterValue: '',
        },
        companyName: {
            filterType: 'like',
            filterValue: '',
        },
        orderDate: {
            filterType: 'like',
            filterValue: '',
        },
        creditDays: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
        status: {
            filterType: 'like',
            filterValue: '',
        },
	}

	const pendingDeliveryAdditionalPostData = {
		idProjects: project.value,
		dateRange: dateRange,
		customFromDate: customDate.customFromDate,
		customToDate: customDate.customToDate,
	};

	const pendingDeliveryUrl = process.env.REACT_APP_API_URL + 'pending-delivery/dt'


	const pendingReceiveColumns = [
		{
			value: 'referenceNo', title: 'PO No', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
				return (
					<>
						<Link to={`/po-details/${row.idPo}`}>
							{row.referenceNo}
						</Link>
					</>
				)
			})
		},
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'vendorName', title: 'Vendor', style: { textAlign: 'left' } },
		{ value: 'purchaseDate', title: 'Purchase Date', style: { textAlign: 'left' } },
		{ value: 'itemName', title: 'Item', style: { textAlign: 'left' } },
		{ value: 'quantity', title: 'Order Quantity', style: { textAlign: 'center' } },
		{ value: 'receivedQuantity', title: 'Received Quantity', style: { textAlign: 'center' } },
		{ value: 'dueQuantity', title: 'Due Quantity', style: { textAlign: 'center' } },
	]

	const pendingReceiveFilters = {
		referenceNo: {
			filterType: 'like',
			filterValue: '',
		},
		projectName: {
			filterType: 'like',
			filterValue: '',
		},
		vendorName: {
			filterType: 'like',
			filterValue: '',
		},
		purchaseDate: {
			filterType: 'like',
			filterValue: '',
		},
		itemName: {
			filterType: 'like',
			filterValue: '',
		},
		quantity: {
			filterType: 'like',
			filterValue: '',
		},
		receivedQuantity: {
			filterType: 'like',
			filterValue: '',
		},
		dueQuantity: {
			filterType: 'like',
			filterValue: '',
		},
	}

	const pendingReceiveAdditionalPostData = {
		idProjects: project.value,
		dateRange: dateRange,
		customFromDate: customDate.customFromDate,
		customToDate: customDate.customToDate,
	};

	const pendingReceiveUrl = process.env.REACT_APP_API_URL + 'dashboard/pendingGoods'

	return (
		<>
			<div style={{ background: "none" }} className='card card-custom'>
				<div className='card-header card-header-stretch overflow-auto'>
					<div className='card-title'>
						<h3 className='card-label'>Store Manager Dashboard</h3>
					</div>
					<div className="card-toolbar">
						<div className='d-flex justify-content-end'>
							{/* <div className='mt-5 mb-2'>
								<select className='form-control' onChange={(event) => handleDateRangeChange(event)}>
									<option value={'year'}>This Year</option>
									<option value={'month'}>This Month</option>
									<option value={''}>Custom</option>
								</select>
							</div>
							{(dateRange === '' || dateRange === 'custom') &&
								<>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<input type='date' className='form-control  form-control-sm' name='customFromDate' onChange={handleCustomDateChange}></input>
									</div>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<input type='date' className='form-control  form-control-sm' name='customToDate' onChange={handleCustomDateChange}></input>
									</div>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<button className='btn-primary form-control  form-control-sm' name='showCustomData' onClick={showCustomDateData}>Show</button>
									</div>
								</>
							} */}
							&nbsp;&nbsp;&nbsp;

							<div className='mt-5 mb-2'>
								<Select
									defaultValue={selectProjectOptions}
									onChange={handleProjectChange}
									options={selectProjectOptions}
									placeholder={project.label}
									menuPosition="fixed"
									styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								/>
							</div>
						</div>
					</div>
				</div>
				{/* {JSON.stringify(activityType)} */}
				<div className="card-body">
					<div className="row gy-5 g-xl-2 mt-4">
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div className="card h-100 bg-light-warning">
								<div className="card-body d-flex justify-content-between align-items-start flex-column">
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{Number(dashboardData.pendingShipments)}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Pending shipments </span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: "#f3d6ef82" }} className="card h-100 bg-light-info">
								<div className="card-body d-flex justify-content-between align-items-start flex-column">
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{Number(dashboardData.alreadyShipped)}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Already shipped </span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: "#f3d6ef82" }} className="card h-100">
								<div className="card-body d-flex justify-content-between align-items-start flex-column">
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{Number(dashboardData.productStock)}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Products in stock </span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div className="card h-100 bg-light-success">
								<div className="card-body d-flex justify-content-between align-items-start flex-column">
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{Number(dashboardData.itemsInStock)}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Items in stock </span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: "#bfdde380" }} className="card h-100">
								<div className="card-body d-flex justify-content-between align-items-start flex-column">
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{Number(dashboardData.productOutOfStock)}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Products out of stock </span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Row className="gy-5 g-xl-2">
						<Col md={12}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										<KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
										<span className='text fw-bolder' style={{ marginLeft: '10px' }}>
											List of Pending Delivery To Do
										</span>
									</div>
									<div className="card-toolbar">
									</div>
								</div>

								<div className='card-body'>
									<DataTable url={pendingDeliveryUrl} columns={pendingDeliveryColumns} filters={pendingDeliveryFilters} additionalPostData={pendingDeliveryAdditionalPostData} newData={newData} />
								</div>
							</div>
						</Col>
					</Row>

					<Row className="gy-5 g-xl-2">
						<Col md={12}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										<KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
										<span className='text fw-bolder' style={{ marginLeft: '10px' }}>
											List of Pending Goods Receive To Do
										</span>
									</div>
									<div className="card-toolbar">
									</div>
								</div>

								<div className='card-body'>
									<DataTable url={pendingReceiveUrl} columns={pendingReceiveColumns} filters={pendingReceiveFilters} additionalPostData={pendingReceiveAdditionalPostData} newData={newData} />
								</div>
							</div>
						</Col>
					</Row>
					
				</div>
			</div>

		</>

	)
}

export default DashboardStoreManager
